export const RESOURCE_TYPE_OFFERING_CATALOGUE_FEATURES =
	'RESOURCE_TYPE_OFFERING_CATALOGUE_FEATURES';
